import { TableCellContent } from "@animech/ui";
import { useContext, useMemo } from "react";
import { useUiData } from "./use-ui-data";
import { useCartPricing } from "./use-cart-pricing";
import { ApiDataContext } from "src/api";

export const UseArticleTableData = () => {
	const { articles } = useContext(ApiDataContext);
	const { localizer } = useUiData();
	const { formatArticleTotalPrice } = useCartPricing();

	const rows = useMemo(() => {
		if (!articles) {
			return [];
		}

		return articles
			.slice()
			.sort((a, b) => a.sku.localeCompare(b.sku))
			.map((article) => ({
				id: article.sku,
				contentArray: [
					{
						content: article.name,
					},
					{
						content: article.sku,
					},
					{
						content: article.color,
					},
					{
						content: article.quantity,
					},

					{
						content: formatArticleTotalPrice(article),
					},
				],
			}));
	}, [articles, formatArticleTotalPrice]);

	const header: TableCellContent[] = [
		{ content: localizer.localizeTerm("cartInventoryColumnName") },
		{ content: localizer.localizeTerm("cartInventoryColumnSku") },
		{ content: localizer.localizeTerm("cartInventoryColumnColor") },
		{ content: localizer.localizeTerm("cartInventoryColumnQuantity") },
		{ content: localizer.localizeTerm("cartInventoryColumnTotal") },
	];

	return { header, articles: rows };
};
